import { NgComponentOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, Type } from '@angular/core';

import { BreakpointDirective, PortalDirective } from '@smw/utils-front';

import { DescriptionComponent } from './description/description.component';
import { ProcessMenuComponent } from './menu/menu.component';
import { ProcessDescription, SectionConfiguration } from './process';
import { SectionComponent } from './section/section.component';
import { ButtonComponent } from '../button/button.component';
import { MenuTriggerDirective } from '../dropdown/menu-trigger.directive';
import { Icon } from '../icon';
import { Position } from '../overlay/overlay';

@Component({
  selector: 'smw-process',
  templateUrl: 'process.component.html',
  styleUrls: ['./process.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgComponentOutlet,
    BreakpointDirective,
    MenuTriggerDirective,
    PortalDirective,
    ProcessMenuComponent,
    SectionComponent,
    DescriptionComponent,
    ButtonComponent,
  ],
})
export class ProcessComponent {
  /** Sorted list of step identifiers */
  steps = input.required<string[]>();
  /** Mapping between step identifiers and the associated components */
  stepComponentsMapping = input.required<Record<string, Type<unknown> | undefined>>();
  /** Mapping between step identifiers and the associated menu item components */
  stepItemComponentsMapping = input.required<Record<string, Type<unknown> | undefined>>();
  /** Configuration of about section */
  aboutConfig = input<SectionConfiguration>();
  /** Configuration of supports section */
  supportsConfig = input<SectionConfiguration>();
  /** Configuration of after section */
  afterConfig = input<SectionConfiguration>();
  /** Optional description resource of the process */
  description = input<ProcessDescription | undefined>();

  menuIcon = Icon.menu;
  menuPosition: Position = { x: 'end-inner', y: 'end-outer' };

  sections = computed(() => {
    const sections = [];
    const aboutConfig = this.aboutConfig();
    const supportsConfig = this.supportsConfig();
    const afterConfig = this.afterConfig();

    if (aboutConfig?.steps.length) {
      sections.push(aboutConfig);
    }

    if (supportsConfig?.steps.length) {
      sections.push(supportsConfig);
    }

    if (afterConfig?.steps.length) {
      sections.push(afterConfig);
    }

    return sections;
  });
}
